import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setSearch } from "../../features/Task/taskSlice";

export default function Navbar() {
  const dispatch = useDispatch();

  const doSeach = (e) => {
    dispatch(setSearch(e.target.value.trim()));
  };

  const debounceSearch = (fn, delay) => {
    let timer;
    return function (arg) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn(arg);
      }, delay);
    };
  };

  const handleChange = debounceSearch(doSeach, 500);

  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to={"/"}>
          <img src={"/assets/images/logo.svg"} alt="logo" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500" />
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            onChange={handleChange}
          />
        </div>
      </div>
    </nav>
  );
}
